module.exports = __webpack_public_path__ + "static/media/galerija_2017 (9).845a7eac.jpg";